import { render, staticRenderFns } from "./recheckDetail.vue?vue&type=template&id=501a078e&scoped=true&"
import script from "./recheckDetail.vue?vue&type=script&lang=js&"
export * from "./recheckDetail.vue?vue&type=script&lang=js&"
import style0 from "./recheckDetail.vue?vue&type=style&index=0&id=501a078e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501a078e",
  null
  
)

export default component.exports